var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.length > 0 && _vm.data != 0)?_c('div',_vm._l((_vm.data),function(item,index){return _c('span',{key:index},[(index > 0)?_c('span',[_vm._v(",")]):_vm._e(),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(item.name))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }